import { ChargeTypeUnits } from '../Common';

export class ChargeTypeGroup {
    id = 0;

    tenantId = 0;

    groupName = '';

    billCharge = 0.0;

    billQuantity = 8.0;

    billUnitId = ChargeTypeUnits.Flat;

    chargeTypes = [];

    quickBooksInventoryItemId = null;

    isRental = false;

    billingCycleId = null;

    isLumpSum = false;
}

export const ChargeTypeGroupStatus = [
    { id: 1, description: 'Active' },
    { id: 2, description: 'Inactive' },
];

export const _ChargeTypeGroupStatuses = {
    Active: 1,
    Inactive: 2,
};
